// components/collab-projects/StationsBody.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setSpaceId, setStationId } from "../../redux/history/history.actions";
import SpaceData from "../spaceData/space-data.component";
import NoSpaceData from "../noSpaceData/no-space-data.component";
// import FavoriteStations from "../favorite-stations/favorite-stations.component";
import CollabProjectTree from "./CollabProjectTree";
import PinnedProjectTree from "../pinned-projects/PinnedProjectTree";
import { useCollabProjects } from "./CollabProjectsProvider";
import { Link } from "react-router-dom";
import { BsEnvelope } from "react-icons/bs";
import { IoSearchOutline, IoPersonCircleOutline } from "react-icons/io5";
import "./collab-projects.scss";

// WorkspaceProjects is supplied by Stations; its folder/drag implementation is unchanged.
export default function StationsBody({ WorkspaceProjects }) {
  const { spaces, workspacesReady } = useCollabProjects();
  const stations = useSelector((s) => s.space.stationData) || [];
  const entitlement = useSelector((s) => s.user.entitlement);
  const currentUser = useSelector((s) => s.user.currentUser);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const parts = pathname.split("/");
  const isWorkspaceRoute =
    parts[1] === "s" && Boolean(parts[2]) && parts[3] !== "e";
  const isProjectRoute =
    parts[1] === "s" &&
    Boolean(parts[2]) &&
    parts[3] === "e" &&
    Boolean(parts[4]);
  const spaceId = isWorkspaceRoute || isProjectRoute ? parts[2] : null;
  const stationId = isProjectRoute ? parts[4] : null;
  const workspace = spaces.find((s) => s.spaceId === spaceId);
  const workspaceStations = stations.filter(
    (p) => (p.spaceId || p.fromSpaceId) === spaceId,
  );
  useEffect(() => {
    dispatch(setSpaceId(spaceId));
    dispatch(setStationId(stationId));
  }, [spaceId, stationId, dispatch]);
  return (
    <div className="stations">
      {!spaceId && (
        <div className="spaces__column">
          <div className="workspaces__title">
            <h3>Workspaces</h3>
          </div>
          {!workspacesReady ? (
            <p role="status">Loading workspaces…</p>
          ) : spaces.length ? (
            <SpaceData />
          ) : (
            <NoSpaceData />
          )}
          <PinnedProjectTree />
          <nav className="stations-quicklinks" aria-label="Personal navigation">
            <Link to="/invites">
              <BsEnvelope />
              <span>Collaboration Invites</span>
            </Link>

            <Link to="/people">
              <IoSearchOutline />
              <span>Find connections</span>
            </Link>

            {currentUser?.uid && (
              <Link to={`/profile/${currentUser.uid}`}>
                <IoPersonCircleOutline />
                <span>My profile page</span>
              </Link>
            )}
          </nav>
        </div>
      )}
      {isProjectRoute && !workspace && (
        <div style={{ marginTop: isProjectRoute && !workspace ? 40 : 0 }}>
          <CollabProjectTree />
        </div>
      )}
      {workspace && (
        <>
          <h2
            className="stations__spacename"
            style={{ textDecoration: `underline 2px ${workspace.color}` }}
          >
            {workspace.name}
          </h2>
          <h5 className="stations__projectstitle">Projects</h5>
          <WorkspaceProjects
            key={spaceId}
            spaceId={spaceId}
            activeId={stationId}
            stations={workspaceStations}
            entitlement={entitlement}
            currentUser={currentUser}
            showCreateControls
          />
        </>
      )}
      {isWorkspaceRoute && !workspace && workspacesReady && (
        <p role="status">This workspace is unavailable.</p>
      )}
    </div>
  );
}
